function init_i18 (key, page) {
  // 注册这个字段
  if (!sessionStorage.trans_str) {
    sessionStorage.trans_str = page + ':' + key
  } else if (sessionStorage.trans_str.indexOf(key) === -1) {
    sessionStorage.trans_str += ',' + key
  }
}
function exist_i18 (key, page, str) {
  let exist_str = {}
  if (!sessionStorage.exist_str) {
    // sessionStorage.exist_str = page + ':' + key
    exist_str = {
      path: page,
      lang_data: [{ sKey: key, sValue: str }]
    }
    sessionStorage.exist_str = JSON.stringify(exist_str)
  } else {
    exist_str = JSON.parse(sessionStorage.exist_str)
    if (exist_str.lang_data) {
      const bool = exist_str.lang_data.find(item => {
        return item.sKey === key
      })
      if (!bool) {
        exist_str.lang_data.push({ sKey: key, sValue: str })
        sessionStorage.exist_str = JSON.stringify(exist_str)
      }
    }
    // exist_str.lang_data.push({ sKey: key, sValue: str })
    // sessionStorage.exist_str = JSON.stringify(exist_str)
  }
}
function tanslat (key, position, page) {
  let str = ''
  const i18_mixins = localStorage.getItem('lang') ? JSON.parse(localStorage.getItem('lang')) : ''
  // const i18_mixins = sessionStorage.getItem('langData') ? JSON.parse(sessionStorage.getItem('langData')) : ''
  // 排除headerBar公共字段
  if (position === 'header') {
    if (i18_mixins['common']) {
      if (i18_mixins['common'][key]) {
        // 返回通用字段
        return i18_mixins['common'][key].sValue ? i18_mixins['common'][key].sValue : key
      } else {
        init_i18(key, 'common')
        return key
      }
    } else {
      init_i18(key, 'common')
      return key
    }
  }
  if (i18_mixins[page] && i18_mixins[page][key]) {
    str = i18_mixins[page][key].sValue
    // if (!str || str === '') {
    //   if (i18_mixins['common']) {
    //     if (i18_mixins['common'][key]) {
    //       // 返回通用字段
    //       if (!str) {
    //         init_i18(key, page)
    //       }
    //       return i18_mixins['common'][key]
    //     }
    //   }
    //   init_i18(key, page)
    //   return key
    // }
    // str不存在
    if (!str && str !== '') {
      init_i18(key, page)
      if (i18_mixins['common']) {
        if (i18_mixins['common'][key]) {
          // 返回通用字段
          return i18_mixins['common'][key].sValue ? i18_mixins['common'][key].sValue : key
        } else {
          return key
        }
      } else {
        return key
      }
    } else {
      // 存在
      exist_i18(key, page, str)
      if (str === '') {
        if (i18_mixins['common']) {
          if (i18_mixins['common'][key]) {
            // 返回通用字段
            return i18_mixins['common'][key].sValue ? i18_mixins['common'][key].sValue : key
          } else {
            return key
          }
        } else {
          return key
        }
      } else {
        return str
      }
    }
  } else {
    if (i18_mixins['common']) {
      if (i18_mixins['common'][key]) {
        // 返回通用字段
        return i18_mixins['common'][key].sValue ? i18_mixins['common'][key].sValue : key
      } else {
        init_i18(key, page)
        return key
      }
    } else {
      init_i18(key, page)
      return key
    }
  }
}
export default tanslat



// WEBPACK FOOTER //
// ./src/utils/trans/index.js